import { createSelector } from 'reselect'
import _ from 'lodash'
import { getMarkupType, getCurrency } from './settings'
import { diamondPriceHelper, jewelryPriceHelper, appraisalCostHelper } from './prices'

export const getDiamondsInCart = state => state.cart.diamonds
export const getJewelryInCart = state => state.cart.jewelry
export const clientBudgetIsAfterTax = state => state.cart.clientBudgetIsAfterTax
export const clientBudget = state => state.cart.clientBudget
export const taxPercent = state => state.cart.taxPercent

export const getDiamondPrices = createSelector(
  getDiamondsInCart,
  getMarkupType,
  getCurrency,
  (diamonds, markupType, currency) => {
    let diamondPrices = {}
    _.forEach(diamonds, (value, key) => {
      diamondPrices[key] = diamondPriceHelper(value.data, markupType, currency)
    })
    return diamondPrices
  }
)

export const getJewelryPrices = createSelector(
  getJewelryInCart,
  getMarkupType,
  getCurrency,
  (jewelry, markupType, currency) => {
    let jewelryPrices = {}
    _.forEach(jewelry, (value, key) => {
      jewelryPrices[key] = jewelryPriceHelper(value.data, markupType, currency)
    })
    return jewelryPrices
  }
)

export const getAppraisalCosts = createSelector(
  getJewelryInCart,
  getCurrency,
  (jewelry, currency) => {
    let appraisalCosts = {}
    _.forEach(jewelry, (jewelryItem, key) => {
      currency = currency.toUpperCase()
      appraisalCosts[key] = appraisalCostHelper(jewelryItem, currency)
    })
    return appraisalCosts
  }
)

export const totalSelectedDiamondPrices = createSelector(
  getDiamondsInCart,
  getMarkupType,
  getCurrency,
  (diamonds, markupType, currency) => {
    const selectedDiamonds = _.values(diamonds).filter((diamond) => {
      return diamond.checkout
    })
    return _.values(selectedDiamonds).reduce((sum, diamond) => {
      return sum + parseFloat(diamondPriceHelper(diamond.data, markupType, currency))
    }, 0)
  }
)

export const totalSelectedJewelryPrices = createSelector(
  getJewelryInCart,
  getMarkupType,
  getCurrency,
  (jewelry, markupType, currency) => {
    const selectedJewelry = _.values(jewelry).filter((item) => {
      return item.checkout
    })
    return _.values(selectedJewelry).reduce((sum, item) => {
      return sum + parseFloat(jewelryPriceHelper(item.data, markupType, currency)) + parseFloat(item[`appraisalCostIn${currency.toUpperCase()}`])
    }, 0)
  }
)

export const clientBudgetBeforeTax = createSelector(
  clientBudget,
  clientBudgetIsAfterTax,
  taxPercent,
  (budget, isAfterTax, taxPercent) => {
    if (isAfterTax) {
      return parseFloat((budget / (1 + (taxPercent / 100))).toFixed(2))
    } else {
      return parseFloat(budget.toFixed(2))
    }
  }
)

export const getClientBudgetForDiamond = createSelector(
  totalSelectedDiamondPrices,
  totalSelectedJewelryPrices,
  clientBudgetBeforeTax,
  (totalDiamondPrice, totalJewelryPrice, budgetBeforeTax) => parseFloat((budgetBeforeTax - totalDiamondPrice - totalJewelryPrice).toFixed(2))
)



// WEBPACK FOOTER //
// ./src/selectors/cart.js